import { guardEmptyArray } from '@portal/utils/util-guards';
import { componentFactory } from 'vue-tsx-support';

import { ObserverVisibility, tsStoreMixin } from '@jtnews/shared';

import { RecordRelatedNews } from '../../components';

type RelatedNews = {
  header: string;
  id: number;
  publishAt: string;
  urls: {
    url: string;
    urlCanonical: string;
    urlComments: string;
  };
  type: 'MN' | 'ML';
};

type ComponentData = {
  isClickedRelatedNewsCounter: boolean;
  obsVisibility: ObserverVisibility;
};

const DEFAULT_FIELD_TYPE = 'По теме (блок)';

export default componentFactory.mixin(tsStoreMixin).create({
  name: 'RecordRelatedNewsContainer',
  props: {
    recordList: {
      type: Array as () => RelatedNews[],
      required: true
    }
  },
  data(): ComponentData {
    return {
      isClickedRelatedNewsCounter: false,
      obsVisibility: new ObserverVisibility('half')
    };
  },
  computed: {
    isCommercial(): boolean {
      const recordBlock = this.store.layoutModule.record;
      const recordData: { isCommercial?: boolean } =
        recordBlock && recordBlock.data ? recordBlock.data : {};
      return recordData?.isCommercial ?? false;
    }
  },
  mounted() {
    this.obsVisibility.event.subscribe(({ value }) => {
      this.onVisibleRelatedNews(value);
    });
  },
  beforeDestroy() {
    this.obsVisibility.destroy();
  },
  methods: {
    onVisibleRelatedNews(isVisible: boolean) {
      if (isVisible) {
        const ids = this.recordList.map(item => item.id).join(',');
        const types = this.recordList.map(item => item.type).join(',');

        this.sendNewReachGoal(
          'По теме',
          { Просмотр: { [ids]: types } },
          'ViewOnThisTopic'
        );
        if (guardEmptyArray(this.recordList)) {
          this.sendNewFormatReachGoal(
            'ViewOnThisTopic',
            'По теме',
            'Просмотр',
            ids,
            types
          );
        }
      }
    },
    clickRelatedNewsCounter() {
      if (this.isClickedRelatedNewsCounter) {
        return;
      }

      this.sendNewReachGoal(DEFAULT_FIELD_TYPE, 'Счетчик тем', 'clickSameThemeBlock');
      this.isClickedRelatedNewsCounter = true;
    },
    clickRelatedNewsBtn() {
      this.sendNewReachGoal(DEFAULT_FIELD_TYPE, 'Показать еще', 'clickSameThemeBlock');
      this.sendNewFormatReachGoal('ClickOnThisTopic', 'По теме', 'Клик', 'Показать еще');
      this.isClickedRelatedNewsCounter = true;
    },
    toRecordFromRelatedNews(record: { id: number; type: string }) {
      const value = {
        Клик: { [record.id]: record.type }
      };

      this.sendNewReachGoal('По теме', value, 'ClickOnThisTopic');
      this.sendNewFormatReachGoal(
        'ClickOnThisTopic',
        'По теме',
        'Клик',
        `${record.id}`,
        record.type
      );
    },
    sendNewReachGoal(
      fieldType: string,
      valueName: string | Record<string, Record<string, string>>,
      goalName: string
    ) {
      const blockType = 'Центральная колонка';

      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName
      });
    },
    sendNewFormatReachGoal(
      goalName: string,
      blockType: string,
      actionType: string,
      prop1: string,
      prop2?: string
    ) {
      this.store.analyticsModule.sendNewFormatReachGoal({
        goalName,
        blockType,
        actionType,
        prop1,
        prop2
      });
    }
  },
  render() {
    return (
      <noindex>
        <RecordRelatedNews
          v-observe-visibility={this.obsVisibility.getOptions('half')}
          isCommercial={this.isCommercial}
          recordList={this.recordList}
          onClickedAlsoBtn={() => this.clickRelatedNewsBtn()}
          onClickedCounter={() => this.clickRelatedNewsCounter()}
          onClickedToRecord={event => this.toRecordFromRelatedNews(event)}
        />
      </noindex>
    );
  }
});
